import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFax = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.99992 8.00004H13.6666C14.0348 8.00004 14.3333 8.29851 14.3333 8.66671V14C14.3333 14.3682 14.0348 14.6667 13.6666 14.6667H2.99992C2.63173 14.6667 2.33325 14.3682 2.33325 14V8.66671C2.33325 8.29851 2.63173 8.00004 2.99992 8.00004ZM3.66659 1.33337H12.9999V6.66671H3.66659V1.33337ZM6.33325 3.33337V4.66671H7.66659V3.33337H6.33325ZM8.99992 3.33337V4.66671H10.3333V3.33337H8.99992Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFax);
export { ForwardRef as ReactComponent };
